if (!customElements.get('varsy-disclosure')) {
  customElements.define(
    'varsy-disclosure',
    class VarsyDisclosure extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.panel = this.querySelector('.disclosure__list-wrapper');
        if (!this.button || !this.panel) return;

        this.button.addEventListener('click', (event) => {
          event.stopPropagation();
          this.toggle();
        });

        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.close();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code === 'Escape') {
            this.close();
            this.button.focus();
          }
        });
      }

      toggle() {
        const expanded = this.button.getAttribute('aria-expanded') === 'true';
        this.button.setAttribute('aria-expanded', String(!expanded));
        this.panel.hidden = expanded;
      }

      close() {
        this.button.setAttribute('aria-expanded', 'false');
        this.panel.hidden = true;
      }
    }
  );
}

/* ── Keep language switches on the current page ──────────────────────────
   Every language link renders with href="{{ language.root_url }}" -- the
   root of that language, i.e. its home page. That's the right no-JS
   fallback, but on its own it drops the customer back to the homepage
   whenever they switch language from a product or collection page.

   Rewrite each link to the SAME page in the target language: strip the
   current locale prefix off the path, then prepend the target language's
   root. Built from window.location rather than Liquid's request.path so
   the prefix handling is exact, and so query strings (collection filters,
   utm tags) survive the switch. */
(function () {
  var links = document.querySelectorAll('[data-vrs-lang-link]');
  if (!links.length) return;

  /* Every non-default language root currently on the page, e.g. /en, /ar.
     The default language's root is "/" and never appears as a prefix. */
  var roots = [];
  links.forEach(function (link) {
    var root = link.dataset.vrsLangRoot;
    if (root && root !== '/' && roots.indexOf(root) === -1) roots.push(root);
  });

  var path = window.location.pathname;

  /* Anchored match only -- "/collections/enfant" must not be treated as
     sitting under the "/en" prefix. */
  var prefix = '';
  roots.forEach(function (root) {
    if (path === root || path.indexOf(root + '/') === 0) prefix = root;
  });

  var rest = prefix ? path.slice(prefix.length) : path;
  if (!rest) rest = '/';

  links.forEach(function (link) {
    var root = link.dataset.vrsLangRoot || '/';
    var base = root === '/' ? '' : root;
    link.setAttribute('href', base + rest + window.location.search);
  });
})();
